module.exports = __webpack_public_path__ + "static/media/ic-notif-licensing-obligation.4e8cfdc8.svg";